// TableWithSums.js
import React from "react";

const TableWithSums = ({ data, onRowClick }) => {
  if (!data || data.length === 0) return null;

  // Get all unique keys from the data for headers
  let headers = Array.from(new Set(data.flatMap((row) => Object.keys(row))));

  // Remove "total"/"potential" from headers so we can place them at the end
  const hasTotal = headers.includes("total");
  const hasPotential = headers.includes("potential");
  if (hasTotal || hasPotential) {
    headers = headers.filter((h) => h !== "total" && h !== "potential");
  }

  // Calculate column sums
  const sums = {};
  headers.forEach((key) => {
    sums[key] = data.reduce((acc, row) => acc + (parseFloat(row[key]) || 0), 0);
  });

  if (hasTotal) {
    sums["total"] = data.reduce((acc, row) => acc + (parseFloat(row["total"]) || 0), 0);
  }

  if (hasPotential) {
    sums["potential"] = data.reduce((acc, row) => acc + (parseFloat(row["potential"]) || 0), 0);
  }

  return (
    <div className="table-responsive">
      <table className="table table-striped table-bordered">
        <thead className="table-dark sticky-top">
          <tr>
            {headers.map((header) => (
              <th key={header}>{header}</th>
            ))}
            {hasTotal && <th>Total</th>}
            {hasPotential && <th>Potential</th>}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
             <tr key={rowIndex} style={{ cursor: onRowClick ? "pointer" : "default" }} onClick={() => onRowClick?.(row)}>
              {headers.map((key) => (
                <td key={key}>{row[key] ?? ""}</td>
              ))}
              {hasTotal && <td>{row.total}</td>}
              {hasPotential && <td>{row.potential}</td>}
            </tr>
          ))}
        </tbody>
        <tfoot className="table-secondary">
          <tr>
            {headers.map((key) => (
              <td key={key}>{sums[key]}</td>
            ))}
            {hasTotal && <td>{sums["total"]}</td>}
            {hasPotential && <td>{sums["potential"]}</td>}
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default TableWithSums;
